// src/pages/Home.js
import { useEffect } from 'react';
import Hero from '../components/Hero';
import CalendarPreview from '../components/CalendarPreview';
import PlannerPreview from '../components/PlannerPreview';

function Home() {
  useEffect(() => {
    document.title = "Deepali Agrawal - Illustrator & Artist | Home";
  }, []);

  return (
    <div className="max-w-7xl mx-auto">
      <Hero />
      <CalendarPreview />
      <PlannerPreview />
    </div>
  );
}

export default Home;